import axios from "axios";
import qs from "qs";
import { Can, getToken } from "../service";
import React from "react";
import { SourceFile } from "../../pages/ResourcePool/service";
import { v4 } from "uuid";
export enum RES_EVENT_PARAMS {
    STUDENT_PERSPECTIVE_PREVIEW_OPEN = "STUDENT_PERSPECTIVE_PREVIEW_OPEN_ON_COURSE_DETAIL"
}

export interface PublicParams {
    courseNo: string; //课程编号
    batchNo: string | undefined; //学期编号
    courseSeq: string; //课程序号
    weektimeId?: number; //计划id（如果课程信息中心带有该参数就传，不带就不传）
    description: string; //说明
    isPublish?: Can; //是否公开
    isDownload?: Can; //是否可以下载
    chapterId: string; //章节id
}

export interface LocalFileItemProps {
    fileName: string;
    fileSize: number;
    fileUrl: string;
}
export interface AddLocalFileProps extends PublicParams {
    fileEntityList: LocalFileItemProps[];
}
export interface FileProps {
    file: File;
    uid: string;
    status: "uploading" | "done" | "error" | "pending" | "stop";
    error?: ErrorEvent;
    percent: number;
    response?: {
        key: string;
        hash: string;
    };
}

//新增课件（上传本地文件）
export function addCoursewareSourceForLocalFile(data: AddLocalFileProps) {
    return axios
        .post<SuccessData<FileProps[]>>(
            "/teacher/coursewareSource/addCoursewareSourceForLocalFile",
            data
        )
        .then(res => res.data.data);
}

export interface HrefItemProps {
    fileName: string;
    viewUrl: string;
}
export interface AddHrefProps extends PublicParams {
    sourceFileEntity: HrefItemProps;
}
//新增课件（上传网页链接）
export function addCoursewareSourceForWebUrl(data: AddHrefProps) {
    return axios
        .post("/teacher/coursewareSource/addCoursewareSourceForWebUrl", data)
        .then(res => res.data.data);
}

export interface PolyvReplayProps extends QueryPolyvReplaySearch {
    pageNo?: number; // 页码
    pageSize?: number; // 页面尺寸
}

export interface QueryPolyvReplaySearch {
    courseName?: string; // 关键词
    batchNo?: string[]; //学期id
    type?: string[]; //回放分类
}

export interface PolyvItem {
    vid: string; //保利威vid
    duration: string;
    createTime: string; //创建时间
    index: number; //序号
    startTime: string; //直播开始时间
    replay: string; //保利威视频回放url(重要：viewUrl)
    time: number; //时间
    title: string; //标题（重要:fileName）
    watchUrl: string; //观看地址（重要：storePath）
    channelId: string; //频道号
}
export interface PolyvReturnItem {
    totalSize: number;
    data: PolyvItem[];
}

//查询保利威回放视频信息列表
export function findPolyvReplayList(data: PolyvReplayProps) {
    return axios
        .post<SuccessData<PolyvReturnItem>>(
            "/teacher/coursewareSource/findPolyvReplayList",
            data
        )
        .then(res => res.data.data);
}

//新 查询保利威回放视频信息列表
export function newfindPolyvReplayList(data: PolyvReplayProps) {
    const batchNo = data.batchNo?.join(",");
    const type = data.type?.join(",");
    const pageNo = data.pageNo;
    const pageSize = data.pageSize;
    const courseName = data.courseName;
    return axios
        .post<SuccessData<PolyvReturnItem | undefined>>(
            "/teacher/coursewareSource/getOnDemandPlayback",
            qs.stringify({ courseName, pageNo, pageSize, batchNo, type })
        )
        .then(res => res.data.data);
}

//预览新保利威直播回放
export interface PlaybackReturnItem {
    channelId: string;
    vid: string;
}
export interface SuccessPlaybackItem {
    replay: string;
    watchUrl: string;
}
export function lookPlayback(data: PlaybackReturnItem) {
    const token = getToken();
    return axios
        .post<SuccessData<SuccessPlaybackItem>>(
            `/teacher/coursewareSource/lookOnDemandPlayback`,
            qs.stringify(data),
            {
                headers: { token }
            }
        )
        .then(res => res.data.data);
}

export interface addPolyvItem {
    storePath: string;
    fileName: string;
    viewUrl: string;
    vid: string;
}
export interface addPolyvProps extends PublicParams {
    sourceFileEntities: addPolyvItem[];
}
//新增课件（上传保利威直播回放）
export function addCoursewareSourceForPolyv(data: addPolyvProps) {
    return axios
        .post("/teacher/coursewareSource/addCoursewareSourceForPolyv", data)
        .then(res => res.data.data);
}

// 将多选的课件合成一个数组来上传
export async function addPolyvitem(checkItem: PolyvItem[]) {
    const sourceFileEntities: addPolyvItem[] = checkItem.map(item => {
        return {
            fileName: item.title,
            viewUrl: item.vid,
            storePath: item.vid,
            vid: item.vid
        };
    });
    return sourceFileEntities;
}

export interface addResProps extends PublicParams {
    sourceIds: React.Key[];
}
//资源库引用
export function addCoursewareSourceForOtherCourseware(data: addResProps) {
    return axios
        .post(
            "/teacher/coursewareSource/addCoursewareSourceForOtherCourseware",
            data
        )
        .then(res => res.data.data);
}

export interface changeStatusProps {
    id: string;
    isPublish: Can;
}
//发布 取消发布
export function pulishCoursewareSource(data: changeStatusProps) {
    return axios
        .post("/teacher/coursewareSource/pulishCoursewareSource", data)
        .then(res => res.data.data);
}

export interface LearnProps {
    id: number;
    courseNo: string;
    keyword: string;
    batchNo: string | undefined; //学期编号
    courseSeq: string;
    weektimeId: number;
    studyStatusEntity: {
        studyStatus: string; //0否1是空全部
    };
}

export interface LearnDataProps {
    batchName: string; // 学期名称
    batchNo: string; // 学期编号
    chapterId: number; // 所属章节id
    courseName: string; // 课程名称
    courseNo: string; // 课程序号
    courseSeq: string; // 课程序号
    createTime: string; // 创建时间
    createUser: number; // 创建人id(上传人id)
    createUserName: string; // 创建人姓名(上传人姓名)
    customerCode: string; // 用户code
    dcCoursewareSourceStatics: DcCoursewareSourceStatics; // 学习状态统计
    id: string; // 课件id
    isDownload: number; // 是否可以下载：0否1是
    isPublish: number; // 是否发布：0否1是
    nodeType: string;
    sourceFileEntity: SourceFile; // 资源文件信息实体
    sourceId: number; // 资源文件id
    studyStatusEntities: StudyStatusEntity[]; // 学生学习状态列表
    /**
     * 0:选择的 1：上传的
     */
    type: number;
    updateTime: string; // 修改时间
    weektimeId: number; // 课程计划id
}
/**
 * 学习状态统计
 */
export interface DcCoursewareSourceStatics {
    dcCoursewareSourceId?: number; // 课件id
    hasLearnNumber?: number; // 已学人数
    notLearnNumber?: number; // 未学人数
    totalNumber?: number; // 总人数
}

/**
 * 资源文件信息实体
 */

export interface StudyStatusEntity {
    coursewareId?: number | null;
    downloadCount?: number;
    id?: number; // 学习状态实体id(可能为空)
    studentId?: number;
    studentMarkModel?: StudentMarkModel; // 学生信息
    studyStatus?: Can; //学习状态
    studyTime?: string; // 学习时间
    keys: string;
}

/**
 * 学生信息
 */
export interface StudentMarkModel {
    className?: string; // 班级名称
    department?: string; // 所属学院
    name?: string; // 学生姓名
    sex?: string; // 性别
    studentId?: number; // 学生id
    studentNo?: string; // 学生学号
    subject?: string; // 专业
}

//获取资源的统计详情
export function getCoursewareLearnStatus(data: LearnProps) {
    return axios
        .post<SuccessData<LearnDataProps>>(
            "/teacher/coursewareSource/getCoursewareLearnStatus",
            data
        )
        .then(res => {
            const arr = res.data.data.studyStatusEntities.map(item => {
                return {
                    ...item,
                    keys: item?.studentMarkModel?.studentId?.toString() || v4()
                };
            });
            res.data.data.studyStatusEntities = arr;
            return res.data.data;
        });
}
